module.exports = __webpack_public_path__ + "static/img/bio-lg.632c38f.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/project-detail/bio-lg.png
// module id = 7y8+
// module chunks = 0